import React from 'react';
import PropTypes from 'prop-types';
import { withRouter, Link } from 'react-router-dom';
import Drawer from '@material-ui/core/Drawer';
import { connect } from 'react-redux';
import NativeTable from '../../../components/NativeTable/NativeTable';

import { Popover, PopoverBody, PopoverHeader, Alert } from 'reactstrap';

import {
    Button,
    ButtonToolbar,
    Dropdown,
    DropdownItem,
    DropdownMenu,
    DropdownToggle
} from "reactstrap";

import Loader from '../../../components/Loader/Loader';
import Widget from '../../../components/Widget/Widget';

import { loadAvailableStations, createStation, updateStation, deleteStation } from '../../../actions/settings'
import { loadMenus, saveStationMenu } from '../../../actions/menus'
import {
    loadVenues,
    loadLayouts,
    fetchStationLayoutSelection,
    saveStationLayoutSelection,
} from '../../../actions/venues'
import StationLayoutBindingControls from '../StationLayoutBindingControls'

import s from './Stations.module.scss';
import { withTranslation } from '../../../i18n/LanguageContext';

class Stations extends React.Component {
    
    static propTypes = {
        products: PropTypes.array,
        dispatch: PropTypes.func.isRequired,
    };

    static defaultProps = {
        products: []
    };

    state = {
        popovers: {},
        promoAlert: false,
        isAddModal: false,
        curStation: null,
        stationName: "",
        stationError: "",
        editNameError: "",
        /** 'inherit' | 'auto' | 'all' | number string of menuId */
        editMenuValue: 'inherit',
        savingMenu: false,
        // stationId → { EnableLayoutMode, PosVenueId, PosLayoutId, saving }
        stationLayoutSelections: {},
        editLayoutSelection: {
            EnableLayoutMode: false,
            PosVenueId: null,
            PosLayoutId: null,
            saving: false,
        },
    };

    constructor() {
        super();
        
        this.changeNewStationName = this.changeNewStationName.bind(this);
        this.changeEditStationName = this.changeEditStationName.bind(this);
        this.editStation = this.editStation.bind(this);
        this.apiFormatter = this.apiFormatter.bind(this);
    }

    loadStations = () => {
        if (this.props.merchant?.MerchantId) {
            this.props.dispatch(loadAvailableStations(this.props.merchant.MerchantId));
        }
        this.props.dispatch(loadMenus(false));
        this.props.dispatch(loadVenues(true));
    }

    componentDidMount() {
        this.loadStations();
        this.ensureLayoutsLoaded(this.props.venues);
        if (this.props.stations && this.props.stations.length) {
            this.hydrateStationLayouts(this.props.stations);
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.merchant?.MerchantId !== this.props.merchant?.MerchantId) {
            this.loadStations();
        }
        if (prevProps.stations !== this.props.stations) {
            this.hydrateStationLayouts(this.props.stations);
        }
        if (prevProps.venues !== this.props.venues) {
            this.ensureLayoutsLoaded(this.props.venues);
        }
    }

    ensureLayoutsLoaded = (venues) => {
        (venues || []).forEach((v) => {
            if (!v || !v.VenueId) return;
            if (this.props.layoutsByVenue[v.VenueId]) return;
            this.props.dispatch(loadLayouts(v.VenueId, true));
        });
    };

    hydrateStationLayouts = async (stations) => {
        if (!Array.isArray(stations) || stations.length === 0) return;
        const next = { ...this.state.stationLayoutSelections };
        let changed = false;
        for (const st of stations) {
            // Skip only when we already have a server-hydrated binding.
            if (next[st.StationId] && next[st.StationId]._hydrated) continue;
            const sel = await fetchStationLayoutSelection(st.StationId);
            next[st.StationId] = sel
                ? {
                    EnableLayoutMode: !!sel.EnableLayoutMode,
                    PosVenueId: sel.PosVenueId || null,
                    PosLayoutId: sel.PosLayoutId || null,
                    saving: false,
                    _hydrated: true,
                }
                : {
                    EnableLayoutMode: false,
                    PosVenueId: null,
                    PosLayoutId: null,
                    saving: false,
                    _hydrated: true,
                };
            if (next[st.StationId].PosVenueId && !this.props.layoutsByVenue[next[st.StationId].PosVenueId]) {
                this.props.dispatch(loadLayouts(next[st.StationId].PosVenueId, true));
            }
            changed = true;
        }
        if (changed) this.setState({ stationLayoutSelections: next });
    };

    layoutLabelForStation = (station) => {
        if (!station) return '—';
        const sel = this.state.stationLayoutSelections[station.StationId];
        if (!sel || !sel.EnableLayoutMode) return this.props.t('layouts.layoutOff');
        const layouts = sel.PosVenueId ? (this.props.layoutsByVenue[sel.PosVenueId] || []) : [];
        const layout = layouts.find((l) => l.LayoutId === sel.PosLayoutId);
        const venue = (this.props.venues || []).find((v) => v.VenueId === sel.PosVenueId);
        if (layout && venue) return `${venue.Name} · ${layout.Name}`;
        if (layout) return layout.Name;
        if (sel.PosLayoutId) return this.props.t('layouts.layoutAssigned');
        return this.props.t('layouts.layoutOn');
    };

    setEditLayoutField = (field, value) => {
        const next = {
            ...this.state.editLayoutSelection,
            [field]: value,
            _hydrated: true,
        };
        if (field === 'PosVenueId') next.PosLayoutId = null;
        this.setState({ editLayoutSelection: next }, () => {
            if (field === 'PosVenueId' && value && !this.props.layoutsByVenue[value]) {
                this.props.dispatch(loadLayouts(value, true));
            }
        });
    };

    changeNewStationName(event) {
        this.setState({ stationName: event.target.value, stationError: "" });
    }

    changeEditStationName(event) {
        var curStation = this.state.curStation;
        curStation.Name = event.target.value;
        this.setState({ curStation: curStation, editNameError: "" });

        this.setState({ stationName: event.target.value, stationError: "" });
    }

    onClickSave = (event) => {
        event.preventDefault();
        console.log("ok")
        const { stationName } = this.state;
        const { merchant } = this.props;
        if (stationName == "") {
            this.setState({stationError: "Please input the station name"});
        } else {
            const payload = {
                MerchantId: merchant.MerchantId,
                Name: stationName,
                AssetId: null,
                DisplayWebsite: '',
                UserTipping: false,
                UserTouchscreen: false,
                EnableSelfCheckout: false,
                DisplayCart: false,
                StationMode: 1,
                Terminal: 'Unassigned'
            }
            this.props.dispatch(createStation(payload));
        }
    }

    onClickUpdate = async (event) => {
        event.preventDefault();

        const { curStation, editMenuValue, editLayoutSelection } = this.state;

        var editNameError = "";
        if (curStation.Name == "") {
            editNameError = "Please input the station name";
        }
        if (!editLayoutSelection || !editLayoutSelection._hydrated) {
            editNameError = this.props.t('layouts.layoutLoading');
        } else if (editLayoutSelection.EnableLayoutMode
            && (!editLayoutSelection.PosVenueId || !editLayoutSelection.PosLayoutId)) {
            editNameError = this.props.t('layouts.pickVenueLayout');
        }

        if (editNameError == "") {
            this.props.dispatch(updateStation(curStation));
            this.setState({ savingMenu: true });
            const selection = editMenuValue === 'inherit'
                ? { inherit: true }
                : editMenuValue === 'auto'
                    ? { inherit: false, useSchedule: true }
                    : editMenuValue === 'all'
                        ? { inherit: false, menuId: null }
                        : { inherit: false, menuId: Number(editMenuValue) };
            await this.props.dispatch(saveStationMenu(curStation.StationId, selection));
            const layoutSaved = await saveStationLayoutSelection({
                StationId: curStation.StationId,
                EnableLayoutMode: !!editLayoutSelection.EnableLayoutMode,
                PosVenueId: editLayoutSelection.PosVenueId || null,
                PosLayoutId: editLayoutSelection.PosLayoutId || null,
            });
            if (!layoutSaved) {
                this.setState({
                    savingMenu: false,
                    editNameError: this.props.t('layouts.layoutSaveFailed'),
                });
                return;
            }
            this.setState({
                stationLayoutSelections: {
                    ...this.state.stationLayoutSelections,
                    [curStation.StationId]: {
                        ...editLayoutSelection,
                        saving: false,
                        _hydrated: true,
                    },
                },
            });
            this.loadStations();
            this.setState({ isAddModal: false, savingMenu: false });
        } else {
            this.setState({editNameError: editNameError});
        }
    }

    editStation = async (stationId) => {
        const station = this.getStationById(stationId);
        let editMenuValue = 'inherit';
        if (station && station.MenuInherit === false) {
            if (station.MenuUseSchedule) {
                editMenuValue = 'auto';
            } else {
                editMenuValue = station.MenuId > 0 ? String(station.MenuId) : 'all';
            }
        }
        const cached = this.state.stationLayoutSelections[stationId];
        let editLayoutSelection = (cached && cached._hydrated)
            ? { ...cached, saving: false }
            : null;

        // Always resolve server binding before opening the drawer so Update
        // cannot wipe an existing assignment with empty defaults.
        if (!editLayoutSelection) {
            const sel = await fetchStationLayoutSelection(stationId);
            editLayoutSelection = sel
                ? {
                    EnableLayoutMode: !!sel.EnableLayoutMode,
                    PosVenueId: sel.PosVenueId || null,
                    PosLayoutId: sel.PosLayoutId || null,
                    saving: false,
                    _hydrated: true,
                }
                : {
                    EnableLayoutMode: false,
                    PosVenueId: null,
                    PosLayoutId: null,
                    saving: false,
                    _hydrated: true,
                };
            this.setState((prev) => ({
                stationLayoutSelections: {
                    ...prev.stationLayoutSelections,
                    [stationId]: editLayoutSelection,
                },
            }));
        }

        if (editLayoutSelection.PosVenueId && !this.props.layoutsByVenue[editLayoutSelection.PosVenueId]) {
            this.props.dispatch(loadLayouts(editLayoutSelection.PosVenueId, true));
        }

        this.setState({
            isAddModal: true,
            curStation: station,
            editMenuValue,
            editLayoutSelection,
            editNameError: '',
        });
    };

    togglePopover = (id) => {
        const popovers = { ...this.state.popovers };
        popovers[id] = !popovers[id];
        this.setState({ popovers });
    }

    confirmDeleteStation = (stationId) => {
        const { merchant } = this.props;
        if (!merchant?.MerchantId) return;
        this.togglePopover(stationId);
        this.props.dispatch(deleteStation(stationId, merchant.MerchantId));
    }

    menuLabelForStation = (station) => {
        if (!station) return '—';
        if (station.MenuInherit !== false) {
            const defId = this.props.defaultMenuId;
            const defName = defId
                ? ((this.props.menus || []).find((x) => x.MenuId === defId)?.Name || 'default')
                : 'All';
            if (this.props.useMenuSchedule) {
                return `Inherit (Auto schedule · ${defName})`;
            }
            return `Inherit (${defName})`;
        }
        if (station.MenuUseSchedule) return 'Auto schedule';
        if (station.MenuId > 0) return station.MenuName || `Menu #${station.MenuId}`;
        return 'All';
    };

    getStationById = (id) => {
        const {stations} = this.props;
        var data = stations.filter(function( s ) {
            return s.StationId == id;
        });

        var station = null;
        if (data.length > 0) {
            station = {... data[0]};
        } 
        return station;
    }

    hideAddModal = (e) => {
        e.preventDefault();
        this.setState({isAddModal: false});
    }

    apiFormatter(cell, row) {
        return (
            <ButtonToolbar className="settings-action">
                <button
                    type="button"
                    id={'popoverDeleteStation_' + row.StationId}
                    className="btn"
                    disabled={this.props.isDeleting && this.props.idToDelete === row.StationId}
                >
                    {this.props.isDeleting && this.props.idToDelete === row.StationId ? (
                        <Loader size={14} />
                    ) : (
                        <div><i className="zmdi zmdi-delete"></i></div>
                    )}
                </button>
                <button type="button" className="btn" onClick={() => this.editStation(row.StationId)}>
                    <div><i className="zmdi zmdi-edit"></i></div>
                </button>
                <Popover
                    className="popover-danger"
                    target={'popoverDeleteStation_' + row.StationId}
                    placement="top"
                    isOpen={!!this.state.popovers[row.StationId]}
                    toggle={() => this.togglePopover(row.StationId)}
                >
                    <PopoverHeader className="px-5">{this.props.t('stations.deleteConfirm')}</PopoverHeader>
                    <PopoverBody className="px-5 d-flex justify-content-center">
                        <ButtonToolbar>
                            <Button color="success" size="xs" onClick={() => this.confirmDeleteStation(row.StationId)}>
                                {this.props.t('common.yes')}
                            </Button>
                            <Button color="danger" size="xs" onClick={() => this.togglePopover(row.StationId)}>
                                {this.props.t('common.no')}
                            </Button>
                        </ButtonToolbar>
                    </PopoverBody>
                </Popover>
            </ButtonToolbar>
        )
    }

    renderSizePerPageDropDown = (props) => {
        const limits = [];
        props.sizePerPageList.forEach((limit) => {
            limits.push(<DropdownItem key={limit}
                                      onClick={() => props.changeSizePerPage(limit)}>{limit}</DropdownItem>);
        });

        return (
            <Dropdown isOpen={props.open} toggle={props.toggleDropDown}>
                <DropdownToggle color="default" caret>
                    {props.currSizePerPage}
                </DropdownToggle>
                <DropdownMenu>
                    {limits}
                </DropdownMenu>
            </Dropdown>
        );
    };

    render() {
        const options = {
            sizePerPage: 10,
            paginationSize: 3,
            sizePerPageDropDown: this.renderSizePerPageDropDown,
        };

        const { t } = this.props;
        const { stationError, editNameError, curStation, isAddModal } = this.state;
        const { stations } = this.props;
        const data = stations;
        
        return (
            <div className={`row stations ${s.stationsRow}`}>
                <div className={`col-12 col-md-5 station ${s.station}`}>
                    <div className="bg-second p-4">
                        <div className="">
                            <h3 className="mt-0 mb-5 text-white">{t('stations.heading')} <small className={`${s.description}`}> {t('stations.intro')}</small></h3>
                        </div>
                        <form>
                            <div className="form-group station-name">
                                <label>{t('stations.name')}</label>
                                <input type="text" className="form-control" placeholder={t('stations.namePlaceholder')} onChange={this.changeNewStationName}/>
                                <p className="px-4">{t('stations.terminal')}: <span className="font-italic"> {t('stations.unassigned')}</span></p>
                            </div>
                            <div className="row alert-container">
                            {
                                stationError && (
                                    <Alert className="alert-sm" color="danger">
                                        {stationError}
                                    </Alert>
                                )
                            }
                            </div>
                            <button type="submit" className="btn pt-2 btn-block" onClick={(e) => this.onClickSave(e)}>{t('stations.save')}</button>
                        </form>
                    </div>
                    <div className="m-4 alert alert-light alert-dismissible fade show" role="alert">
                        <strong>{t('stations.note')}</strong> {t('stations.noteBody')}
                        <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                            <span aria-hidden="false">×</span>
                        </button>
                    </div>   
                </div>
                <div className={`col-12 col-md-7 second-box`}>
                    <div className="bg-second p-4">
                        <div className="form-group">
                            <div className={`d-flex align-items-center px-2 mb-3 text-white py-2 ${s.available_stations}`}>
                                <h4>
                                    {t('stations.available')} <small > </small>
                                </h4>
                            </div>  
                        </div>  
                        <Widget>
                            <div className="order_list">
                                <NativeTable
                                    data={data}
                                    columns={[
                                        { key: 'Name', header: t('stations.name') },
                                        { key: 'Terminal', header: t('stations.terminal') },
                                        {
                                            key: 'MenuId',
                                            header: t('stations.menu'),
                                            render: (_cell, row) => this.menuLabelForStation(row),
                                        },
                                        {
                                            key: 'Layout',
                                            header: t('stations.layout'),
                                            render: (_cell, row) => this.layoutLabelForStation(row),
                                        },
                                        { key: 'StationId', header: '', render: (cell, row) => this.apiFormatter(cell, row) },
                                    ]}
                                />
                            </div>
                        </Widget>
                    </div>   
                </div>
                <Drawer anchor="right" open={isAddModal} onClose={this.hideAddModal}>
                    <div className="add_category_model add_expenses receipt_model px-0" 
                        id="add_expenses" tabIndex="-1" role="dialog" aria-labelledby="receipt_modelTitle" aria-modal="true">
                        <div className="modal-dialog modal-dialog-scrollable" role="document">
                            <div className="modal-content">
                                <div className="modal-header px-0">
                                    <h2 className="col-10 mx-auto">{t('stations.editName')}</h2>
                                </div>
                                <div className="row alert-container">
                                {
                                    editNameError && (
                                        <Alert className="alert-sm" color="danger">
                                            {editNameError}
                                        </Alert>
                                    )
                                }
                                </div>
                                <div className="modal-body p-0">
                                    <form>
                                        <div className="col-10 mx-auto form_container">
                                            {
                                                curStation == null ? (
                                                    <div></div>
                                                ) : (
                                                    <>
                                                    <div className="form-group">
                                                        <label>{t('stations.name')}</label>
                                                        <input type="text" className="form-control" value={curStation.Name} onChange={this.changeEditStationName}/>
                                                    </div>
                                                    <div className="form-group">
                                                        <label>{t('stations.menu')}</label>
                                                        <select
                                                            className="form-control"
                                                            value={this.state.editMenuValue}
                                                            onChange={(e) => this.setState({ editMenuValue: e.target.value })}
                                                        >
                                                            <option value="inherit">{t('stations.inherit')}</option>
                                                            <option value="auto">{t('stations.autoSchedule')}</option>
                                                            <option value="all">{t('stations.allCatalog')}</option>
                                                            {(this.props.menus || [])
                                                                .filter((m) => m.IsActive)
                                                                .slice()
                                                                .sort((a, b) => (a.SortOrder - b.SortOrder) || String(a.Name).localeCompare(String(b.Name)))
                                                                .map((m) => (
                                                                    <option key={m.MenuId} value={String(m.MenuId)}>{m.Name}</option>
                                                                ))}
                                                        </select>
                                                        <small className="text-muted">
                                                            {t('stations.menuHelp')}
                                                        </small>
                                                    </div>
                                                    <div className="form-group">
                                                        <label>{t('stations.layout')}</label>
                                                        <StationLayoutBindingControls
                                                            stationId={curStation.StationId}
                                                            selection={this.state.editLayoutSelection}
                                                            venues={this.props.venues}
                                                            layouts={
                                                                this.state.editLayoutSelection.PosVenueId
                                                                    ? (this.props.layoutsByVenue[this.state.editLayoutSelection.PosVenueId] || [])
                                                                    : []
                                                            }
                                                            t={t}
                                                            showSave={false}
                                                            onChange={this.setEditLayoutField}
                                                        />
                                                        <small className="text-muted">
                                                            {t('stations.layoutHelp')}
                                                        </small>
                                                    </div>
                                                    </>
                                                )
                                            }
                                        </div>

                                        <div className="modal-footer">
                                            <div className="row no-gutters w-100">
                                                <div className="col-6"> <button type="file" className="btn Cencel" onClick={(e) => this.hideAddModal(e)}>{t('common.cancel')}</button></div>
                                                <div className="col-6"> <button type="file" className="btn" onClick={(e) => this.onClickUpdate(e)} disabled={this.state.savingMenu}>{t('common.update')}</button></div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </Drawer>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        merchant: state.auth.merchant,
        stations: state.settings.stations,
        menus: state.menus.list,
        defaultMenuId: state.menus.defaultMenuId,
        useMenuSchedule: state.menus.useMenuSchedule,
        venues: (state.venues && state.venues.venues) || [],
        layoutsByVenue: (state.venues && state.venues.layoutsByVenue) || {},
        isReceiving: state.settings.isReceiving,
        isUpdating: state.settings.isUpdating,
        isDeleting: state.settings.isDeleting,
        idToDelete: state.settings.idToDelete,
    };
}

export default withRouter(connect(mapStateToProps)(withTranslation(Stations)));

